"use strict";

angular.module('PatientApp').factory('BrandingConfigService', function (VuexStore) {
  return {
    getConfig: function getConfig() {
      return VuexStore.dispatch('getBrandingConfig');
    }
  };
});